import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid, Typography } from "@mui/material";
import { UsinasContext } from "../context/UsinasContextProvider";
import NumberInput from "../../../main/components/NumberInput";
import { Indicators, PostUsina } from "../types";
import { ConfirmIndicatorsChangesModal } from "./ConfirmIndicatorsChangesModal";
import { checkIfIndicatorsAreDifferent } from "../divergentIndicators";
import MWhHistoryTable from "./MWhHistoryTable";
// import TextInput from "../../../main/components/TextInput";

const schema = yup.object().shape({
  value: yup
    .number()
    .optional()
    .nullable()
    .transform((value) => (isNaN(value) ? 0 : value)),
});

export type MWhValueData = yup.InferType<typeof schema>;

const MWhValueForm = React.forwardRef(
  (
    props: {
      selectedStep: number;
      setSelectedStep: (step: number) => void;
    },
    ref
  ) => {
    const { newUsina, setNewUsina, currentIndicators, setCurrentIndicators } =
      useContext(UsinasContext);
    const [
      openConfirmIndicatorsChangeModal,
      setOpenConfirmIndicatorsChangeModal,
    ] = useState(false);
    const {
      handleSubmit,
      control,
      formState: { errors },
      setValue,
      watch,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const formData: MWhValueData = watch();
    const newIndicators: Indicators = {
      megaWattValue: formData.value,
    };
    function updateData() {
      const data = newUsina?.indicators?.megaWattValue;
      if (!data && data != 0) {
        setValue("value", undefined);
      } else {
        setValue("value", data);
      }
    }
    const path = window.location.pathname;
    const isRegister = path.includes("cadastrar");
    useEffect(() => {
      updateData();
      if (isRegister) {
        return;
      }
      setCurrentIndicators(newUsina?.indicators);
    }, []);

    const onSubmit = (data: MWhValueData) => {
      if (isRegister) {
        confirmSubmit(data);
      } else {
        const indicatorsAreDifferent = checkIfIndicatorsAreDifferent(
          "MWValueForm",
          currentIndicators,
          newIndicators
        );
        if (indicatorsAreDifferent) {
          setOpenConfirmIndicatorsChangeModal(true);
        } else {
          confirmSubmit(data);
        }
      }
    };
    function confirmSubmit(data: MWhValueData) {
      const newUsinaData: PostUsina = {
        ...newUsina,
        indicators: { ...newUsina?.indicators, megaWattValue: data.value },
      };
      setNewUsina(newUsinaData);
      props.setSelectedStep(props.selectedStep + 1);
    }
    React.useImperativeHandle(ref, () => ({
      submitForm() {
        handleSubmit(onSubmit)();
      },
    }));
    return (
      <Grid
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          height: "100%",
          rowGap: "20px",
          paddingX: "10px",
        }}
      >
        {/* <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "20px",
          }}
        > */}
        {/* <PVSystUpload /> */}
        {/* </Grid> */}
        <Grid
          width={"100%"}
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          spacing={2}
          container
        >
          <Grid item xs={12} textAlign={"start"}>
            <Typography
              variant="h6"
              sx={{
                borderBottom: "1px solid #ccc",
                paddingBottom: 1,
                marginBottom: "15px",
              }}
            >
              Valor do MWh
            </Typography>
          </Grid>
          <Grid display={"flex"} item xs={12} md={3} justifyContent={"center"}>
            <NumberInput
              sx={{ width: "100%", maxWidth: "280px", marginBottom: "30px" }}
              control={control}
              fieldName="value"
              label="Valor do MWh"
              errors={errors}
            />
          </Grid>
          {!isRegister && (
            <Grid
              sx={{
                marginBottom: "20px",
              }}
            >
              <MWhHistoryTable />
            </Grid>
          )}
          <ConfirmIndicatorsChangesModal
            open={openConfirmIndicatorsChangeModal}
            setOpen={setOpenConfirmIndicatorsChangeModal}
            onConfirm={confirmSubmit}
            newIndicators={newIndicators}
            fromScreen="MWhValueForm"
            formData={formData}
          />
        </Grid>
      </Grid>
    );
  }
);

export default MWhValueForm;
